const ImageSliderItem = (props) => {
  const { inner } = props;
  return (
    <div className="slider-inner">{inner}</div>
  );
};

export default ImageSliderItem;
